import {
  SET_POTALCODES,
  SET_SELECTED_LOADCLASS,
  SET_TERRITORIES,
  SET_SELECTED_TERRITORY,
  SET_TERRITORY_COLORS
} from '../types';

export function setZipCodes (data) {
  return {
    type: SET_POTALCODES,
    data
  };
}

export function setRequest (data, type) {
  return {
    type: type,
    data: data
  };
}

export function setTerritories (data) {
  return {
    type: SET_TERRITORIES,
    data
  };
}

export function setTerritoryColors (data) {
  return {
    type: SET_TERRITORY_COLORS,
    data
  };
}

export function setSelectedLoadClass (data) {
  return {
    type: SET_SELECTED_LOADCLASS,
    data
  };
}

export function setSelectedTerritory (data) {
  return {
    type: SET_SELECTED_TERRITORY,
    data
  };
}
